/* Menús compactos Frikirama: evita superposiciones de paneles */
(() => {
  const init = () => {
    document.querySelectorAll('.frk-topnav').forEach(nav => {
      if (nav.dataset.frkMenuInitialized) return;
      nav.dataset.frkMenuInitialized = '1';
      const dropdowns = [...nav.querySelectorAll('.frk-topnav__list > .frk-topnav__node > details.frk-topnav__dropdown')];
      const close = except => dropdowns.forEach(item => { if (item !== except) item.open = false; });
      dropdowns.forEach(item => item.addEventListener('toggle', () => { if (item.open) close(item); }));
      // El desplazamiento de la página cierra el megamenú, también si el encabezado sticky desaparece.
      let lastScrollY = window.scrollY || window.pageYOffset || 0;
      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY || window.pageYOffset || 0;
        if (currentScrollY !== lastScrollY) close(null);
        lastScrollY = currentScrollY;
      }, { passive: true });
      // Al variar la anchura de ventana, evita que un panel abierto quede descolocado.
      window.addEventListener('resize', () => close(null), { passive: true });
      // Busca marcas dentro del panel sin llamadas de red.
      const brandSearch = nav.querySelector('.frk-topnav__brands-search');
      if (brandSearch) {
        const brandGroups = [...nav.querySelectorAll('.frk-topnav__brand-group')];
        const emptyNotice = nav.querySelector('.frk-topnav__brands-empty');
        brandSearch.addEventListener('input', () => {
          const term = brandSearch.value.trim().toLocaleLowerCase('es');
          let visibleCount = 0;
          brandGroups.forEach(group => {
            let inGroup = 0;
            group.querySelectorAll('.frk-topnav__brand-entry').forEach(entry => {
              const matched = entry.textContent.toLocaleLowerCase('es').includes(term);
              entry.hidden = !matched;
              if (matched) {inGroup++;visibleCount++;}
            });
            group.hidden = inGroup === 0;
          });
          if (emptyNotice) emptyNotice.hidden = visibleCount > 0;
        });
      }
      document.addEventListener('pointerdown', event => { if (!nav.contains(event.target)) close(null); });
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const opened = dropdowns.find(item => item.open);
        if (opened) {
          close(null);
          const summary = opened.querySelector(':scope > summary');
          if (summary) summary.focus();
        }
      });
      nav.addEventListener('click', event => {
        if (event.target.closest('.frk-topnav__panel a')) close(null);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();